import { render, staticRenderFns } from "./ImportCodeManageView.vue?vue&type=template&id=368c8e3f&scoped=true&"
import script from "./ImportCodeManageView.vue?vue&type=script&lang=js&"
export * from "./ImportCodeManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368c8e3f",
  null
  
)

export default component.exports